import RandingStyle15 from "../../randing/RandingStyle15";

function Randing048({ urlCode, urlCodeSettingId }) {
  const treatments = [
    { value: "be0244bd-ec2f-45bb-83e0-d82ae746381c", label: "임플란트" },
    { value: "4185c549-c636-4fb4-b787-1e6c2baa37fe", label: "치아교정" },
    { value: "a27aa18a-2877-4757-b875-160e4eb8aad7", label: "일반치료" },
  ];
  return (
    <RandingStyle15
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/048/25010201.jpg`}
      scrollBtn1={[
        `${process.env.REACT_APP_CDN_BASE}/images/048/25010201scroll1.jpg`,
        "img5Path",
      ]}
      scrollBtn2={[
        `${process.env.REACT_APP_CDN_BASE}/images/048/25010201scroll2.jpg`,
        "img9Path",
      ]}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/048/25010202.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/048/25010203.gif`}
      slider1Path={[
        `${process.env.REACT_APP_CDN_BASE}/images/048/slider1/25010204_1.gif`,
        `${process.env.REACT_APP_CDN_BASE}/images/048/slider1/25010204_2.gif`,
        `${process.env.REACT_APP_CDN_BASE}/images/048/slider1/25010204_3.gif`,
      ]}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/048/25010205.jpg`}
      img6Path={`${process.env.REACT_APP_CDN_BASE}/images/048/25010206.jpg`}
      img7Path={`${process.env.REACT_APP_CDN_BASE}/images/048/25010207.jpg`}
      slider2Path={[
        `${process.env.REACT_APP_CDN_BASE}/images/048/slider2/25010208_1.gif`,
        `${process.env.REACT_APP_CDN_BASE}/images/048/slider2/25010208_2.gif`,
        `${process.env.REACT_APP_CDN_BASE}/images/048/slider2/25010208_3.gif`,
      ]}
      img9Path={`${process.env.REACT_APP_CDN_BASE}/images/048/25010209.jpg`}
      img10Path={`${process.env.REACT_APP_CDN_BASE}/images/048/25010210.jpg`}
      img11Path={`${process.env.REACT_APP_CDN_BASE}/images/048/25010211.jpg`}
      img12Path={`${process.env.REACT_APP_CDN_BASE}/images/048/25010212.jpg`}
      img13Path={`${process.env.REACT_APP_CDN_BASE}/images/048/25010213.jpg`}
      img14Path={`${process.env.REACT_APP_CDN_BASE}/images/048/25010214.jpg`}
      img15Path={`${process.env.REACT_APP_CDN_BASE}/images/048/25010215.jpg`}
      img16Path={`${process.env.REACT_APP_CDN_BASE}/images/048/25010216.jpg`}
      privacyMessage="개인정보수집에 동의하시는 분만'신청하기'버튼을 눌러주세요."
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyBenefitButton_small.png`}
      companyName="광교365리움치과병원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/gwanggyo.jpg`}
      articleOption={true}
      eventDates={true}
      treatments={treatments}
      treatmentQ={`${process.env.REACT_APP_CDN_BASE}/images/048/25010217.png`}
      treatmentsImg={`${process.env.REACT_APP_CDN_BASE}/images/048/treatments`}
    />
  );
}

export default Randing048;
